export default "__VITE_ASSET__Drb7paI4__"